<template>
  <div class="organizations">
    <page-header title="Organizations">
      <div slot="sub-title">
        <i class="el-icon-news" />
        Organization management
      </div>
      <div slot="controls">
        <el-button type="primary" class="add-organization-button white-button" icon="el-icon-plus" @click="showDialog = true" plain>Add organization</el-button>
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding mobile-padding">
      <el-col :span="24" v-loading="loading">
        <el-table
          v-if="!loading"
          :data="organizations"
          @cell-click="gotoOrganization"
          style="width: 100%;">
            <el-table-column
              prop="name"
              label="Name">
            </el-table-column>
            <el-table-column
              fixed="right"
              width="90">
              <template slot-scope="scope">
                <table-control icon="el-icon-edit" :obj="scope.row" @update="updateOrganization">
                  <template slot-scope="slotProps">
                    <upsert-form :organization="slotProps.obj" @updated="slotProps.update" />
                  </template>
                </table-control>
              </template>
            </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" :visible.sync="showDialog" :show-close="false" width="450px" top="1.5vh" custom-class="dialog-no-padding dialog-invert full-width-mobile">
      <upsert-form
          @created="addOrganization"
          v-if="showDialog" />
    </el-dialog>

  </div>
</template>

<script>
import Search from '@/components/shared/Search'
import UpsertForm from './UpsertForm'
import TableControl from '@/components/shared/TableControls'

export default {
  name: 'Organizations',
  components: { Search, UpsertForm, TableControl },
  data () {
    return {
      showDialog: false,
      loading: true,
      search: {
        name: ''
      },
      organizations: []
    }
  },
  computed: {},
  methods: {
    addOrganization (org) {
      this.organizations.unshift(org)
      this.showDialog = false
    },
    updateOrganization (org, updated) {
      const index = this.organizations.indexOf(org)
      for (let k in updated) {
        this.organizations[index][k] = updated[k]
      }
    },
    gotoOrganization (row, column, cell, event) {
      if (column.label === 'Name') {
        this.$router.push({ name: 'AdminOrganization', params: { orgId: row.id } })
      }
    },
    async getOrganizations () {
      const response = await this.$http.get(this.$api.organizations.index)
      this.organizations = response.data
      this.loading = false
    }
  },
  created () {
    this.getOrganizations()
  }
}
</script>

<style lang="scss" scoped>
  .hide-slide {
    display: none;
  }

  .slide-out {
    position: absolute;
    right: -33.3333%;
    transition: all ease 0.4s;
  }

  .slide-out-active {
    right: 0px;
  }

  .slide-in {
    width: 100%;
    transition: all ease 0.4s;
  }

  .slide-in-active {
    width: 66.6666%;
  }

  .organization-filter-controls {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .filter-select {
      margin-right: 20px;
    }
  }

  .org-controls {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .org-title {
    font-size: 14px;
    margin-top: 30px;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/Organizations.vue